import script from "./SlideAnimationPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./SlideAnimationPanel.vue?vue&type=script&lang=ts&setup=true"

import "./SlideAnimationPanel.vue?vue&type=style&index=0&id=1489d3ed&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1489d3ed"]])

export default __exports__